import * as prismic from "@prismicio/client";
import { PrismicDocument } from "@prismicio/client";

// Definition der Custom Types
interface SingleDocument extends PrismicDocument {
  type: "Seite";
  // Hier kannst du weitere spezifische Felder deines Single-Dokument-Typs definieren
}

// Repository Name
export const repositoryName: string = "dergoldbroiler";

// Client Konfiguration mit TypeScript
export const client = prismic.createClient<SingleDocument>(repositoryName, {
  accessToken: "",
  routes: [
    {
      type: "seite",
      path: "/",
    },
  ],
}); 